(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("VueFormLayer", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["VueFormLayer"] = factory(require("vue"));
	else
		root["VueFormLayer"] = factory(root["vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_16__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateId; });
/* unused harmony export offset */
/* unused harmony export scroll */
/* unused harmony export clone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debounce; });
var hasOwnProperty = Object.prototype.hasOwnProperty;

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

var generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var offset = function offset(target) {
  if (!target || !target.offsetParent) return false;
  var top = 0;
  var left = 0;
  while (target.offsetParent) {
    top += target.offsetTop;
    left += target.offsetLeft;
    target = target.offsetParent;
  }
  return {
    top: top,
    left: left
  };
};

var scroll = function scroll() {
  if (window.pageYOffset != null) {
    return {
      left: window.pageXOffset,
      top: window.pageYOffset
    };
  } else if (document.compatMode == 'CSS1Compat') {
    return {
      left: document.documentElement.scrollLeft,
      top: document.documentElement.scrollTop
    };
  }
  return {
    left: document.body.scrollLeft,
    top: document.body.scrollTop
  };
};

var clone = function clone(obj) {
  var o = obj instanceof Array ? [] : {};
  for (var k in obj) {
    o[k] = obj[k];
  }
  return o;
};

var debounce = function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var immediate = arguments[2];

  var timeout = void 0;

  return function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  };
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return off; });
/* unused harmony export removeBody */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParentNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enableEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDomClientRect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var isServer = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer;

// 用来绑定事件的方法，它是一个自执行的函数，会根据是否运行于服务器和是否支持addEventListener来返回一个function
var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, function (e) {
          handler(e);
        }, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, function (e) {
          handler(e);
        });
      }
    };
  }
}();

// 解除绑定事件
var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

var removeBody = function removeBody(self, ref) {
  var pos = self.$refs[ref];
  if (pos && pos.$el && pos.$el.parentNode === document.body) {
    document.body.removeChild(pos.$el);
  } else if (pos && pos.parentNode === document.body) {
    document.body.removeChild(pos);
  }
};

var getParentNodes = function getParentNodes(parent) {
  var parentNodes = [window];
  while (parent !== document.body) {
    parentNodes.push(parent);
    if (!parent.parentNode || parent.parentNode.name) return parentNodes;
    parent = parent.parentNode;
  }
  return parentNodes;
};

var enableEventListener = function enableEventListener(parentNodes, handler) {
  parentNodes.forEach(function (p) {
    p.addEventListener('resize', handler, {
      passive: true
    });
    p.addEventListener('scroll', handler, {
      passive: true
    });
  });
};

var removeEventListener = function removeEventListener(parentNodes, handler) {
  parentNodes.forEach(function (p) {
    p.removeEventListener('resize', handler);
    p.removeEventListener('scroll', handler);
  });
};

var getDomClientRect = function getDomClientRect(target) {
  var targetRect = target.getBoundingClientRect();
  var top = targetRect.top;
  var bottom = targetRect.bottom;
  var left = targetRect.left;
  var right = targetRect.right;
  var width = targetRect.width || right - left;
  var height = targetRect.height || bottom - top;
  return {
    x: left + document.documentElement.scrollLeft,
    y: right + document.documentElement.scrollTop,
    width: width,
    height: height,
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_emitter__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueForm",
  componentName: "VueForm",
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_emitter__["a" /* default */]],
  props: {
    model: [Object, Array],
    layer: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelWidth: String,
    labelPosition: String,
    lineHeight: {
      type: String,
      default: "32px"
    },
    itemGutter: {
      type: Number,
      default: 0
    },
    response: {
      type: Boolean,
      default: true
    },
    rowledge: {
      type: String,
      default: "24px"
    }
  },
  data: function data() {
    return {
      layerCopy: Object.freeze(null),
      initModel: Object.freeze(null),
      isResponse: false,
      initLayer: Object.freeze([]),
      reload: true,
      layerComponents: [],
      layerSwich: {}
    };
  },

  computed: {
    formClass: function formClass() {
      var formClass = "";
      this.labelPosition && (formClass += "vue-form--label-" + this.labelPosition);
      this.response && this.isResponse && (formClass += " vue-form-response");
      return formClass;
    }
  },
  created: function created() {
    var _this = this;

    this.layerComponents = [];
    this.$on("popover.show", function (prop) {
      _this.$emit("show", prop);
    });
    this.$on("popover.hide", function (prop) {
      _this.$emit("hide", prop);
    });
    this.$on("layer.add", function (obj) {
      _this.layerComponents.push(obj);
    });
    this.init();
  },

  watch: {
    layer: {
      handler: function handler() {
        var _this2 = this;

        this.reload = false;
        this.initLayer = Object.freeze([]);
        this.$nextTick(function () {
          _this2.reload = true;
          _this2.init();
        });
      },

      deep: false
    }
  },
  methods: {
    formationLayer: function formationLayer() {
      return (this.layer || []).reduce(function (acc, cur) {
        var show = cur.show === undefined ? true : cur.show;
        (cur.data || []).forEach(function (da) {
          da.id = cur.id;
          var layer = _extends({}, cur.view, da, { show: show });
          var findIndex = acc.findIndex(function (l) {
            return l.prop === da.prop;
          });
          if (findIndex === -1) {
            acc.push({
              prop: da.prop,
              layer: [layer]
            });
          } else {
            acc[findIndex].layer.push(layer);
          }
        });
        return acc;
      }, []);
    },
    init: function init() {
      this.initLayer = Object.freeze(this.formationLayer());
      this.initLayerFn();
      this.initModelFn();
    },
    initLayerFn: function initLayerFn() {
      this.layerCopy = Object.freeze(JSON.parse(JSON.stringify(this.initLayer)));
    },
    initModelFn: function initModelFn() {
      this.model && (this.initModel = Object.freeze(JSON.parse(JSON.stringify(this.model))));
    },
    changeShow: function changeShow(id) {
      !id && console.error("changeShow \u65B9\u6CD5\u5FC5\u987B\u4F20\u5165 layer id");
      if (!this.layer.find(function (d) {
        return d.id && d.id === id;
      })) console.error("not find " + id + " in layer");
      this.layerComponents.forEach(function (d) {
        d.layer.changeShow(id);
      });
    },
    recalculate: function recalculate(id, callback) {
      if (typeof callback !== "function") {
        console.error("recalculate方法 回调参数必须是 函数");
        return;
      }
      if (!id) {
        console.error("recalculate方法 必须传入 layer ID");
        return;
      }
      this.recalculateField(id);
      var valid = true;
      (this.initLayer || []).forEach(function (da) {
        if (da.id === id) {
          (da.data || []).find(function (d) {
            return d.data;
          }) && (valid = false);
        }
      });
      callback(valid);
    },
    recalculateEmit: function recalculateEmit(obj) {
      console.log(obj);
      this.$emit('recalculate', obj);
    },
    recalculateField: function recalculateField(id, prop) {
      !id && console.error("recalculateField \u65B9\u6CD5\u5FC5\u987B\u4F20\u5165 layer id");
      !this.model && console.error("model is not define");
      this.layerComponents.forEach(function (d) {
        d.layer.recalculateField(id, prop);
      });
    },
    clearCalculate: function clearCalculate(id) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var resetModel = arguments[2];

      this.layerComponents.forEach(function (d) {
        d.layer.clearCalculate(id, props = [], resetModel);
      });
    },
    resetData: function resetData(prop) {
      var _this3 = this;

      // 初始化值
      if (!this.initModel) return;
      !this.model && console.error("model is not define");

      if (Array.isArray(this.model)) {
        (this.model || []).forEach(function (d, i) {
          _this3.$set(d, prop, _this3.initModel[i][prop] || "");
        });
      } else {
        this.$set(this.model, prop, this.initModel[prop] || "");
      }
    },
    resetFields: function resetFields(id) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      this.clearCalculate(id, props, true);
    }
  },
  mounted: function mounted() {
    if (this.response) {
      var width = void 0;
      if (window.innerWidth) {
        width = window.innerWidth;
      } else if (document.body && document.body.clientWidth) {
        width = document.body.clientWidth;
      }
      if (width <= 768) {
        this.isResponse = true;
      }
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueFormLine",
  props: {
    cols: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: String,
    required: Boolean,
    span: {
      type: Number,
      default: 24
    },
    labelWidth: String
  },
  computed: {
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.name;
      while (parentName !== "VueForm") {
        parent = parent.$parent;
        parentName = parent.$options.name;
      }
      return parent;
    },

    // 间距
    itemGutter: function itemGutter() {
      return this.form.itemGutter / 2;
    },

    // 响应式
    isResponse: function isResponse() {
      return this.form.isResponse;
    }
  },
  render: function render(h) {
    var _this = this;

    // 获取节点
    var slotNodes = this.$slots.default.filter(function (d, i) {
      return _this.$slots.default[i].tag;
    });
    var nodes = []; // form-line 实际插入的节点
    var abreastSlotNodes = []; // form-item 内并排节点
    // form-line 节点处理
    (slotNodes || []).forEach(function (slotNode, index) {
      var remainSpace = 24;
      var remainNodeNum = slotNodes.length;
      (_this.cols || []).forEach(function (d) {
        if (d.span) {
          remainSpace -= d.span;
          remainNodeNum--;
        }
      });
      var span = void 0,
          label = void 0,
          labelWidth = void 0,
          prop = void 0,
          required = void 0,
          value = void 0;
      if (_this.cols && _this.cols.length && _this.cols[index]) {
        span = _this.cols[index].span || remainSpace / remainNodeNum;
        label = _this.cols[index].label || "";
        labelWidth = _this.cols[index].labelWidth || _this.labelWidth || _this.form.labelWidth || "80px";
        prop = _this.cols[index].prop || "";
        required = _this.cols[index].required || false;
      } else {
        span = remainSpace / remainNodeNum;
      }
      _this.isResponse && (span = 24);

      var layerRow = _this.form.initLayer.find(function (d) {
        return d.prop === prop;
      });
      var hasColor = layerRow && (layerRow.layer || []).find(function (l) {
        return l.referenceBorderColor;
      });
      var referenceBorderColor = hasColor && hasColor.referenceBorderColor;
      slotNode = h("render-slot", {
        ref: "renderSlot",
        attrs: { slotNode: slotNode,
          referenceBorderColor: referenceBorderColor
        }
      });

      // 图层分发到 slotNode
      layerRow && (slotNode = h(
        "vue-layer",
        {
          attrs: { layer: layerRow.layer, prop: layerRow.prop }
        },
        [slotNode]
      ));

      // slotNode 分发
      if (!_this.label) {
        // 基本布局
        nodes.push(h(
          "vue-col",
          {
            attrs: { span: span },
            style: { padding: "0 " + _this.itemGutter + "px" } },
          [h(
            "vue-form-item",
            {
              attrs: {
                label: label,
                labelWidth: labelWidth,
                required: required
              }
            },
            [slotNode]
          )]
        ));
      } else {
        // 并列布局
        abreastSlotNodes.push([h(
          "vue-col",
          {
            attrs: { span: span },
            "class": "form-line--abreast" },
          [slotNode]
        )]);
      }
    });
    // 并列布局添加节点
    if (this.label) {
      nodes.push(h(
        "vue-form-item",
        {
          attrs: {
            label: this.label,
            labelWidth: this.labelWidth || "80px",
            required: this.required
          },
          style: { padding: "0 " + this.itemGutter + "px" }
        },
        [abreastSlotNodes]
      ));
    }
    var span = this.isResponse ? 24 : this.span;
    return h(
      "vue-col",
      {
        attrs: { span: span }
      },
      [h(
        "div",
        { "class": "vue-form-line" },
        [nodes]
      )]
    );
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueFormItem",
  props: {
    label: String,
    labelWidth: String,
    required: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.name;
      while (parentName !== "VueForm") {
        parent = parent.$parent;
        parentName = parent.$options.name;
      }
      return parent;
    },
    lineHeight: function lineHeight() {
      return this.form.lineHeight;
    },

    // 行距
    rowledge: function rowledge() {
      return this.form.rowledge;
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_emitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VuePopover",
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_emitter__["a" /* default */]],
  props: {
    referenceId: String,
    // 需要监听的事件
    trigger: {
      type: String,
      default: "hover"
    },
    effect: {
      type: String,
      default: "dark"
    },
    borderColor: String,
    // popover消息提示
    data: [String, Object, Array],
    disabled: [Boolean, Number],
    placement: {
      type: String,
      default: "top"
    },
    placementId: String,
    betraye: Object, // 叛逆者对象
    placementObj: Object, // popover 各个方向成员
    visibleArrow: {
      type: Boolean,
      default: true
    },
    showAlways: Boolean,
    positions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    enterable: Boolean,
    popoverClass: String,
    hideDelay: {
      type: Number,
      default: 200
    },
    prop: String
  },
  data: function data() {
    return {
      reference: null,
      show: false,
      addedBody: false,
      timeoutPending: null,
      momentPlacement: this.placement,
      parentNodes: []
    };
  },

  watch: {
    show: function show(val) {
      if (this.showAlways) return;
      if (val) {
        this.$emit.apply(this.form, ["popover.show", this.prop]);
        this.popoverAddedBody();
        this.calculateCoordinate();
      } else {
        this.$emit.apply(this.form, ["popover.hide", this.prop]);
      }
    },

    // 叛逆者管理
    momentPlacement: function momentPlacement(val) {
      val === this.placement ? this.$emit("removeBetrayer", {
        id: this.placementId,
        placement: this.placement
      }) : this.$emit("addBetrayer", {
        id: this.placementId,
        placement: this.placement
      });
    }
  },
  computed: {
    // 对应方向是否有多个图层
    isMorePlacement: function isMorePlacement() {
      var _this = this;

      var isMorePlacement = false;
      if (['top', 'bottom'].find(function (d) {
        return d === _this.placement;
      })) {
        this.placementObj['top'].length + this.placementObj['bottom'].length >= 2 && (isMorePlacement = true);
      }
      if (['left', 'right'].find(function (d) {
        return d === _this.placement;
      })) {
        return this.placementObj['left'].length + this.placementObj['right'].length >= 2 && (isMorePlacement = true);
      }
      return isMorePlacement;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.name;
      while (parentName !== "VueForm") {
        parent = parent.$parent;
        parentName = parent.$options.name;
      }
      return parent;
    },
    isVisible: function isVisible() {
      return (this.showAlways || this.show) && !this.disabled;
    },
    pClass: function pClass() {
      return (this.effect ? "is-" + this.effect : "is-light") + "  vue-popover__" + this.momentPlacement + " " + (this.popoverClass || "") + " " + (this.isVisible ? "vue-popover--visible" : "vue-popover--hidden");
    },
    popoverStyle: function popoverStyle() {
      var style = {
        "--borderColor": "#ccc",
        "--bgColor": "#fff"
      };
      if (typeof this.effect === "string") {
        switch (this.effect) {
          case "light":
            style["--borderColor"] = "#ccc";
            style["--bgColor"] = "#fff";
            break;
          case "dark":
            style["--borderColor"] = "#303133";
            style["--bgColor"] = "#303133";
            style["--color"] = "#fff";
            break;
          case "info":
            style["--borderColor"] = "#e6a23c";
            style["--bgColor"] = "#e6a23c";
            style["--color"] = "#fff";
            break;
          case "error":
            style["--borderColor"] = "#f56c6c";
            style["--bgColor"] = "#f56c6c";
            style["--color"] = "#fff";
            break;
          default:
            style["--borderColor"] = this.borderColor || this.effect;
            style["--bgColor"] = this.effect;
            style["--color"] = "#fff";
            break;
        }
      }
      return style;
    }
  },
  methods: {
    popoverAddedBody: function popoverAddedBody() {
      if (!this.addedBody && (this.show || this.showAlways)) {
        document.body.appendChild(this.$el);
        this.addedBody = true;
      }
    },
    triggerClick: function triggerClick(e) {
      var popover = this.$el;
      var trigger = this.reference;
      if (!popover || !trigger || !e.target) return;
      if (trigger.contains(e.target)) {
        !this.disabled && (this.show = !this.show);
      } else if (popover.contains(e.target)) {
        return;
      } else {
        this.show = false;
      }
    },
    doShow: function doShow() {
      if (!this.disabled && this.trigger !== "click") {
        if (this.timeoutPending) {
          clearTimeout(this.timeoutPending);
          this.show = true;
        } else {
          this.show = true;
        }
      }
    },
    doHide: function doHide() {
      var _this2 = this;

      if (!this.disabled && this.trigger !== "click") {
        this.timeoutPending = setTimeout(function () {
          _this2.show = false;
        }, this.hideDelay);
      }
    },
    mouseenterWrap: function mouseenterWrap() {
      this.enterable && clearTimeout(this.timeoutPending);
    },
    mouseleaveWrap: function mouseleaveWrap() {
      var _this3 = this;

      if (this.enterable && this.trigger !== "click") {
        this.timeoutPending = setTimeout(function () {
          _this3.show = false;
        }, 200);
      }
    },
    scrollChange: function scrollChange() {
      if (this.isVisible) {
        this.calculateCoordinate(); // 可见的popover实时计算位置
      } else {
        this.isMorePlacement && Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* debounce */])(this.calculateCoordinate)(); // 不可见的popover,如果是多图层，位置计算开启节流
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      var referenceId = document.getElementById(_this4.referenceId);
      if (!referenceId) return;
      _this4.reference = referenceId.children[0];
      _this4.parentNodes = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* getParentNodes */])(_this4.reference);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* enableEventListener */])(_this4.parentNodes, _this4.scrollChange);
      _this4.calculateCoordinate();

      if (_this4.trigger === "hover") {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e" /* on */])(_this4.reference, "mouseenter", _this4.doShow);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e" /* on */])(_this4.reference, "mouseleave", _this4.doHide);
      } else if (_this4.trigger === "focus") {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e" /* on */])(_this4.reference, "focus", _this4.doShow);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e" /* on */])(_this4.reference, "blur", _this4.doHide);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e" /* on */])(window, "click", _this4.triggerClick);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.reference || !this.reference.nodeName) return;
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["f" /* removeEventListener */])(this.parentNodes, this.scrollChange);

    if (this.trigger === "hover") {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* off */])(this.reference, "mouseenter", this.doShow);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* off */])(this.reference, "mouseleave", this.doHide);
    } else if (this.trigger === "focus") {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* off */])(this.reference, "focus", this.doShow);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* off */])(this.reference, "blur", this.doHide);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* off */])(window, "click", this.triggerClick);
    }
    this.addedBody && document.body.removeChild(this.$el);
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueCol",
  props: {
    span: Number
  },
  data: function data() {
    return {};
  },

  computed: {
    style: function style() {
      var style = {};

      if (this.gutter) {
        style.paddingLeft = this.gutter / 2 + "px";
        style.paddingRight = style.paddingLeft;
      }

      if (this.span) {
        style.width = Math.floor(this.span / 24 * 100 * 10000) / 10000 + "%";
      } else {
        style.width = '100%';
      }

      return style;
    },
    gutter: function gutter() {
      var parent = this.$parent;
      while (parent && parent.$options.name !== "VueRow") {
        parent = parent.$parent;
      }
      return parent ? parent.gutter : 0;
    }
  },
  methods: {}
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueContent",
  props: ["data"],
  render: function render(h) {
    return h(
      "div",
      { "class": "vue-layer__content" },
      [this.data]
    );
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueText",
  props: {
    referenceId: String,
    data: [String, Object, Array],
    disabled: Boolean,
    effect: String,
    placement: {
      type: String,
      default: "bottom"
    }
  },
  data: function data() {
    return {
      reference: null
    };
  },

  methods: {
    calculateCoordinate: function calculateCoordinate() {
      if (!this.$el) return;
      switch (this.placement) {
        case "top":
          this.$el.style.top = -this.$el.offsetHeight - 3 + "px";
          break;
        case "right":
          this.$el.style.width = this.$el.offsetWidth + "px";
          this.$el.style.left = this.reference.offsetWidth + 3 + "px";
          break;
        case "bottom":
          break;
        case "left":
          this.$el.style.width = this.$el.offsetWidth + "px";
          this.$el.style.left = -this.$el.offsetWidth - 3 + "px";
          break;
        default:
          console.error("placement 必须是 top/right/bottom/left");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.reference = document.getElementById(_this.referenceId);
      _this.calculateCoordinate();
    });
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueLayer",
  props: {
    prop: String,
    layer: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      betraye: {
        left: [],
        right: [],
        top: [],
        bottom: []
      },
      addLayer: false,
      layerData: Object.freeze(this.layer),
      resetLayerData: Object.freeze(JSON.parse(JSON.stringify(this.layer)))
    };
  },

  computed: {
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.name;
      while (parentName !== "VueForm") {
        parent = parent.$parent;
        parentName = parent.$options.name;
      }
      return parent;
    }
  },
  render: function render(h) {
    var defaultReferenceId = "" + Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["b" /* generateId */])() + this.prop + "/default";
    var referenceNode = h(
      "div",
      {
        attrs: { id: defaultReferenceId },
        "class": "vue-layer__reference" },
      [this.$slots.default[0]]
    );
    var placementObj = {
      left: [],
      right: [],
      top: [],
      bottom: []
    };
    var layers = [];
    for (var i = 0, len = (this.layerData || []).length; i < len; i++) {
      var d = this.layerData[i];
      var referenceId = "" + Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["b" /* generateId */])() + this.prop + "/" + i; // 参考点id
      var data = typeof d.template === "function" ? d.template(d.data, this.prop) : d.data; // 展示内容

      if (!d.type || d.type === "popover") {
        var placement = d.placement || "top"; // 默认展示位置
        var disabled = d.disabled === true || d.show === false ? 1 : 0; // 是否禁用
        var placementId = defaultReferenceId + "/" + placement + "/" + (placementObj[placement].length + 1);
        if (typeof d.reference === "function") {
          layers.push(h(
            "div",
            {
              attrs: { id: referenceId },
              "class": "vue-popover__reference-function" },
            [d.reference()]
          ));
          placementId = "";
        } else {
          referenceId = defaultReferenceId;
          placementObj[placement].push({
            id: placementId,
            disabled: disabled
          });
        }
        // 图层懒加载
        (d.showAlways || this.addLayer) && layers.push(h("vue-popover", {
          attrs: {
            referenceId: referenceId,
            placementId: placementId,
            data: data,
            placement: placement,
            trigger: d.trigger,
            effect: d.effect,
            visibleArrow: d.visibleArrow,
            order: d.order,
            disabled: disabled,
            borderColor: d.borderColor,
            showAlways: d.showAlways,
            enterable: d.enterable,
            popoverClass: d.popoverClass,
            hideDelay: d.hideDelay,
            prop: this.prop,
            betraye: this.betraye,
            placementObj: placementObj
          },
          on: {
            "addBetrayer": this.addBetrayer,
            "removeBetrayer": this.removeBetrayer
          }
        }));
      } else if (d.type === "text") {
        referenceNode = h(
          "div",
          {
            attrs: { id: referenceId },
            "class": "vue-text" },
          [referenceNode]
        );
        layers.push(h("vue-text", {
          attrs: {
            referenceId: referenceId,
            placement: d.placement,
            data: data,
            effect: d.effect,
            disabled: d.disabled
          }
        }));
      } else {}
    }
    return h(
      "div",
      { "class": "vue-layer", on: {
          "mouseenter": this.layerLoad
        }
      },
      [referenceNode, layers]
    );
  },

  methods: {
    // 计算叛逆列表
    addBetrayer: function addBetrayer(betrayer) {
      betrayer.id && !this.betraye[betrayer.placement].find(function (d) {
        return d === betrayer.id;
      }) && this.betraye[betrayer.placement].push(betrayer.id);
    },
    removeBetrayer: function removeBetrayer(betrayer) {
      var index = this.betraye[betrayer.placement].findIndex(function (d) {
        return d === betrayer.id;
      });
      index !== -1 && this.betraye[betrayer.placement].splice(index, 1);
    },

    // 加载图层
    layerLoad: function layerLoad() {
      if (!this.addLayer) {
        this.addLayer = true;
      }
    },
    changeShow: function changeShow(id) {
      this.layerData.forEach(function (d) {
        d.id === id && (d.show = !d.show);
      });
    },
    recalculateField: function recalculateField(id, prop) {
      var _this = this;

      this.layerLoad();
      this.layerData = Object.freeze(this.layerData.map(function (d) {
        if (d.id !== id || !d.recalculate || prop && _this.prop !== prop) return d;
        typeof d.recalculate !== "function" && console.error("recalculate \u5FC5\u987B\u662F function");
        // 获取 value
        var p = prop || _this.prop;
        var key = p.substring(p.lastIndexOf("/") + 1);
        var value = Array.isArray(_this.form.model) ? _this.form.model[p.split("/")[p.split("/").length - 2] * 1][key] : _this.form.model[key] || _this.$set(_this.form.model, key, "");

        // 获取重算返回对象
        var cb = d.recalculate(value) || null;
        d.data = cb.message;
        d.referenceBorderColor = cb.referenceBorderColor;
        d.disabled = cb.disabled;
        if ((typeof cb === "undefined" ? "undefined" : _typeof(cb)) === "object") {
          Array.isArray(cb) && console.error("recalculate 返回值必须是 object");
        } else {
          console.error("recalculate 返回值必须是 object");
        }
        _this.updateSlot(d.referenceBorderColor);
        _this.form.recalculateEmit({ id: d.id, prop: _this.prop, data: d.data });
        return d;
      }));
    },
    clearCalculate: function clearCalculate(id) {
      var _this2 = this;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var resetModel = arguments[2];

      this.layerData = Object.freeze(this.layerData.map(function (d, i) {
        if (d.id !== id) return d;
        var resetObj = _this2.resetLayerData[i];
        if (props.length && props.find(function (prop) {
          return prop === _this2.prop;
        }) || !props.length) {
          _this2.updateSlot(_this2.resetLayerData[i].referenceBorderColor);
          resetModel && _this2.form.resetData(_this2.prop.substring(_this2.prop.lastIndexOf("/") + 1));
          d.data = resetObj.data;
          d.referenceBorderColor = resetObj.referenceBorderColor;
          d.disabled = resetObj.disabled;
          return d;
        }
      }));
    },
    updateSlot: function updateSlot(referenceBorderColor) {
      this.$children[0].update(referenceBorderColor);
    }
  },
  mounted: function mounted() {
    // console.log(this.$children[0])
    this.$emit.apply(this.form, ["layer.add", { prop: this.prop, layer: this }]);
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "RenderSlot",
  componentName: "RenderSlot",
  props: ["slotNode", "referenceBorderColor"],
  render: function render(h) {
    return this.slotNode;
  },
  data: function data() {
    return {
      focusNode: null,
      borderColor: this.referenceBorderColor
    };
  },

  watch: {
    borderColor: function borderColor(val) {
      var _this = this;

      this.$nextTick(function () {
        if (_this.focusNode !== _this.$el) {
          _this.focusNode.style.borderColor = val || "#dcdfe6";
        } else {
          _this.$el.style.borderColor = val || "transparent";
        }
      });
    }
  },
  methods: {
    allChildNodes: function allChildNodes(node, names) {
      // 1.创建全部节点的数组
      var allCN = [];
      names.find(function (d) {
        return d === node.nodeName;
      }) && allCN.push(node);

      // 2.递归获取全部节点
      var getAllChildNodes = function getAllChildNodes(node, names, allCN) {
        // 获取当前元素所有的子节点nodes
        var nodes = node.childNodes;
        // 获取nodes的子节点
        for (var i = 0; i < nodes.length; i++) {
          var child = nodes[i];
          // 判断是否为指定类型节点
          if (names.find(function (d) {
            return d === child.nodeName;
          })) {
            allCN.push(child);
          }
          getAllChildNodes(child, names, allCN);
        }
      };
      getAllChildNodes(node, names, allCN);
      // 3.返回全部节点的数组
      return allCN;
    },
    update: function update(borderColor) {
      this.borderColor = borderColor;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var focusNodes = _this2.allChildNodes(_this2.$el, ["TEXTAREA", "INPUT", "SELECT"]);
      if (focusNodes.length === 1) {
        _this2.focusNode = focusNodes[0];
      } else {
        _this2.focusNode = _this2.$el;
        _this2.focusNode.style.cssText = "border: 1px solid " + (_this2.borderColor || "transparent");
      }
    });
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_form__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_form_line__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_form_item__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_popover__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_col__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_content__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_text__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_layer__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_render_slot__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scss_index_scss__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__scss_index_scss__);
/* jshint esversion: 6 */












var components = [__WEBPACK_IMPORTED_MODULE_0__lib_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__lib_form_line__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__lib_form_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__lib_popover__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__lib_col__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__lib_content__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__lib_text__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__lib_layer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__lib_render_slot__["a" /* default */]];
var VueForm = function VueForm(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  VueForm(window.Vue);
}

/* harmony default export */ __webpack_exports__["default"] = (VueForm);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(15);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__form__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__form__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__form__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form__["a" /* default */]);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a97ac8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(17);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a97ac8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/form/form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34a97ac8", Component.options)
  } else {
    hotAPI.reload("data-v-34a97ac8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reload
    ? _c(
        "form",
        {
          ref: "vueForm",
          staticClass: "vue-form",
          class: _vm.formClass,
          style: { margin: "0 -" + _vm.itemGutter / 2 + "px" }
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34a97ac8", esExports)
  }
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_line__ = __webpack_require__(19);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__form_line__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__form_line__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__form_line__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_line__["a" /* default */]);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_line_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_line_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/form-line/form-line.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-398bc658", Component.options)
  } else {
    hotAPI.reload("data-v-398bc658", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_item__ = __webpack_require__(21);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__form_item__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__form_item__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__form_item__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_item__["a" /* default */]);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_433352d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_item_vue__ = __webpack_require__(22);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_433352d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/form-item/form-item.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-433352d6", Component.options)
  } else {
    hotAPI.reload("data-v-433352d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vue-form-item",
      class: { "is-required": _vm.required },
      style: { marginBottom: _vm.rowledge, "--lineHeight": _vm.lineHeight }
    },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "vue-form-item__label",
              style: { flex: "0 0 " + _vm.labelWidth }
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "formItemContent", staticClass: "vue-form-item__content" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-433352d6", esExports)
  }
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(24);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__popover__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__popover__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__popover__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__popover__["a" /* default */]);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popover_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fefe2e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popover_vue__ = __webpack_require__(26);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fefe2e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/popover/popover.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5fefe2e8", Component.options)
  } else {
    hotAPI.reload("data-v-5fefe2e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(2);


function $(params) {
  return document.getElementById(params);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // 获取参考点ID
    getReferenceId: function getReferenceId() {
      var _this = this;

      if (this.placementId) {
        var samePlacementArr = this.placementObj[this.placement].sort(this.compare("disabled"));
        var index = samePlacementArr.findIndex(function (d) {
          return d.id === _this.placementId;
        });
        if (index !== -1 && samePlacementArr[index - 1]) return samePlacementArr[index - 1].id; // 取同向的前一个
      }
    },
    compare: function compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },

    // 参考点是否在叛逆列表
    referenceInBetrayet: function referenceInBetrayet() {
      var _this2 = this;

      return this.betraye[this.placement].find(function (d) {
        return d === _this2.getReferenceId();
      });
    },

    // 获取变化后的参考点
    getChangeReference: function getChangeReference(placement) {
      var _this3 = this;

      var last = this.placementObj[placement].find(function (d, i) {
        return i === _this3.placementObj[placement].length - 1;
      }); // 取反方向的最后一个
      return last ? $(last.id) : this.reference;
    },
    getPlacementAllRect: function getPlacementAllRect() {
      var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.placement;

      var width = 0;
      var height = 0;
      (this.placementObj[placement] || []).forEach(function (d) {
        height += Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])($(d.id)).height + 12;
        width += Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])($(d.id)).width + 12;
      });
      return {
        width: width,
        height: height
      };
    },
    calculateCoordinate: function calculateCoordinate() {
      !this.addedBody && this.popoverAddedBody();
      var popoverRect = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.$el);
      var reference = $(this.getReferenceId()) || this.reference;
      var referenceRect = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(reference);
      var referenceRectCount = referenceRect;
      var position = {
        top: 0,
        left: 0

        // 判断是否改变方向与确定最终参考点
      };switch (this.placement) {
        case "top":
          if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).top - this.getPlacementAllRect().height < 0 && Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).bottom + this.getPlacementAllRect("bottom").height > window.innerHeight) {
            this.momentPlacement = "top";
            break;
          }
          if (this.referenceInBetrayet()) {
            this.momentPlacement = "bottom";
          } else {
            if (referenceRect.top - popoverRect.height - 12 < 0) {
              this.momentPlacement = "bottom";
              reference = this.getChangeReference(this.momentPlacement);
              referenceRectCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(reference);
            } else {
              this.momentPlacement = "top";
            }
          }
          break;
        case "left":
          if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).left - this.getPlacementAllRect().width < 0 && Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).right + this.getPlacementAllRect("right").width > window.innerWidth) {
            this.momentPlacement = "left";
            break;
          }
          if (this.referenceInBetrayet()) {
            this.momentPlacement = "right";
          } else {
            if (referenceRect.left - popoverRect.width - 12 < 0) {
              this.momentPlacement = "right";
              reference = this.getChangeReference(this.momentPlacement);
              referenceRectCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(reference);
            } else {
              this.momentPlacement = "left";
            }
          }
          break;
        case "right":
          if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).left - this.getPlacementAllRect("left").width < 0 && Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).right + this.getPlacementAllRect().width > window.innerWidth) {
            this.momentPlacement = "right";
            break;
          }
          if (this.referenceInBetrayet()) {
            this.momentPlacement = "left";
          } else {
            if (referenceRect.right + popoverRect.width + 12 > window.innerWidth) {
              this.momentPlacement = "left";
              reference = this.getChangeReference(this.momentPlacement);
              referenceRectCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(reference);
            } else {
              this.momentPlacement = "right";
            }
          }
          break;
        case "bottom":
          if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).top - this.getPlacementAllRect("top").height < 0 && Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(this.reference).bottom + this.getPlacementAllRect().height > window.innerHeight) {
            this.momentPlacement = "bottom";
            break;
          }
          if (this.referenceInBetrayet()) {
            this.momentPlacement = "top";
          } else {
            if (referenceRect.bottom + popoverRect.height + 12 > window.innerHeight) {
              this.momentPlacement = "top";
              reference = this.getChangeReference(this.momentPlacement);
              referenceRectCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* getDomClientRect */])(reference);
            } else {
              this.momentPlacement = "bottom";
            }
          }
          break;
        default:
          console.error("Wrong placement prop");
      }
      // 计算节点坐标
      switch (this.momentPlacement) {
        case "top":
          position.left = referenceRectCount.left - popoverRect.width / 2 + referenceRectCount.width / 2;
          position.top = referenceRectCount.top - popoverRect.height - 12;
          break;
        case "left":
          position.left = referenceRectCount.left - popoverRect.width - 12;
          position.top = referenceRectCount.top + referenceRectCount.height / 2 - popoverRect.height / 2;
          break;
        case "right":
          position.left = referenceRectCount.left + referenceRectCount.width + 12;
          position.top = referenceRectCount.top + referenceRectCount.height / 2 - popoverRect.height / 2;
          break;
        case "bottom":
          position.left = referenceRectCount.left - popoverRect.width / 2 + referenceRectCount.width / 2;
          position.top = referenceRectCount.top + referenceRectCount.height + 12;
          break;
        default:
          console.error("Wrong placement prop");
      }
      this.$el.style.top = position.top + "px";
      this.$el.style.left = position.left + "px";
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        ref: "popover",
        staticClass: "vue-popover",
        class: _vm.pClass,
        style: _vm.popoverStyle,
        attrs: { id: _vm.placementId },
        on: { mouseenter: _vm.mouseenterWrap, mouseleave: _vm.mouseleaveWrap }
      },
      [
        _vm.visibleArrow
          ? _c("div", { staticClass: "vue-popover__arrow" })
          : _vm._e(),
        _vm._v(" "),
        _c("vue-content", { attrs: { data: _vm.data } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fefe2e8", esExports)
  }
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__col__ = __webpack_require__(28);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__col__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__col__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__col__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__col__["a" /* default */]);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_col_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00744fc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_col_vue__ = __webpack_require__(29);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_col_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00744fc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_col_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/col/col.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00744fc4", Component.options)
  } else {
    hotAPI.reload("data-v-00744fc4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-col", style: _vm.style },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00744fc4", esExports)
  }
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__content__ = __webpack_require__(31);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__content__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__content__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__content__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__content__["a" /* default */]);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/content/content.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-667c6690", Component.options)
  } else {
    hotAPI.reload("data-v-667c6690", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text__ = __webpack_require__(33);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__text__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__text__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__text__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__text__["a" /* default */]);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77354c3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__ = __webpack_require__(34);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77354c3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/text/text.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77354c3c", Component.options)
  } else {
    hotAPI.reload("data-v-77354c3c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-content", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: !_vm.disabled,
        expression: "!disabled"
      }
    ],
    ref: "vueTextContent",
    staticClass: "vue-text-content",
    class: "vue-text__" + _vm.placement,
    style: { color: _vm.effect },
    attrs: { data: _vm.data }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77354c3c", esExports)
  }
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layer__ = __webpack_require__(36);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__layer__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__layer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__layer__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__layer__["a" /* default */]);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layer_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layer_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/layer/layer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ae09980", Component.options)
  } else {
    hotAPI.reload("data-v-3ae09980", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__render_slot__ = __webpack_require__(38);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__render_slot__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__render_slot__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__render_slot__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__render_slot__["a" /* default */]);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_render_slot_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_render_slot_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/lib/render-slot/render-slot.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b943d48", Component.options)
  } else {
    hotAPI.reload("data-v-0b943d48", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});